import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const StoreSummary = ({ name , streetName , streetNumber , actions , className , title  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Card, {
        "data-t": "service-store-summary",
        className: className
    }, /*#__PURE__*/ React.createElement(Card.Content, null, (actions === null || actions === void 0 ? void 0 : actions.onEdit) && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: actions.onEdit,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "store-summary--caption"
    }, title !== null && title !== void 0 ? title : getLabel('checkout.serviceStore.title')), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, name), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, streetName, " ", streetNumber)));
};

export { StoreSummary };
//# sourceMappingURL=StoreSummary.js.map
